<div class="modal-header" *ngIf="IsModal">
  <h5 *ngIf="selected && selected.id > 0"  class="modal-title">Modifica Sede</h5>
  <h5 *ngIf="selected  && selected.id == undefined" class="modal-title" >Aggiungi Sede</h5>
  <button type="button" class="close" (click)="closeBtnClick()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div *ngIf="selected && selected != null" class="modal-body">
  <div class="col-12">
    <div class="form-group">
      <label for="indirizzo" class="control-label col-form-label">Nome:</label>
      <input type="text" required [(ngModel)]="selected.nome" class="form-control" id="indirizzo" placeholder="Nome">
    </div>
  </div>
  <div class="col-12">
    <div class="form-group">
      <label for="note" class="control-label col-form-label">Descrizione:</label>
      <textarea type="text" [(ngModel)]="selected.descrizione" class="form-control" id="note" placeholder="Descrizione"></textarea>
    </div>
  </div>
</div>
<div class="d-md-flex align-items-center p-3" style="padding-right: 25px;">
  <button (click)="saveModalButton()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">
    <span class="ml-1 text-white font-weight-bold"> Salva </span>
    <i-feather name="save" class="feather-md "></i-feather>
  </button>
</div>
